import { InfoButton } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import type { Ticket, TicketPriceModalInfoProps } from '../../../model';
import { useToggle } from '../../../../../../../../common/custom-hooks/toggle';
import { TicketPriceInfoModal } from '../../common/TicketPriceInfoModal';

interface TicketPriceInfoWrapperProps {
  isRyanAirTicketingOrMarketingCarrierPresent: boolean;
  isVI: boolean;
  ticket: Ticket;
  ticketPriceModalInfo: TicketPriceModalInfoProps;
}

export const TicketPriceInfoWrapper = ({
  isRyanAirTicketingOrMarketingCarrierPresent,
  isVI,
  ticket,
  ticketPriceModalInfo,
}: TicketPriceInfoWrapperProps) => {
  const { t } = useTranslation();
  const { isOpen, handleOpen, handleClose } = useToggle();

  const infoButtonLabel = t('ScreenReader.PriceSpecification.InfoButton');

  return (
    <>
      <InfoButton
        data-testid="ticket-info-and-price-specification"
        label={infoButtonLabel}
        onClick={handleOpen}
      />
      {ticketPriceModalInfo && (
        <TicketPriceInfoModal
          handleClose={handleClose}
          isOpen={isOpen}
          isRyanAirTicketingOrMarketingCarrierPresent={isRyanAirTicketingOrMarketingCarrierPresent}
          isVI={isVI}
          ticket={ticket}
          ticketPriceModalInfo={ticketPriceModalInfo}
        />
      )}
    </>
  );
};
